import { Injectable } from '@angular/core';
import { Observable, of, from, fromEvent, filter, map } from 'rxjs';
import {Adventure} from './adventure';

const crudURL = 'https://crudcrud.com/api/982d60592994436db5558841fb05d7fa/sins'
const openerURLs = ['https://fivescene.sourceforge.io', 'http://localhost:8030']

const demoGame = {
  title: 'Adventure',
  version: '1.0',
  author: 'me',
  start: {
    place: 'Home',
    intro: ''
  },
  places: [
    {
      title: '(Trade)',
      enter: 'useless',
      description: '',
      find_money: false,
      early: [
        {
          then: 'You get a coin.',
          count: [
            {
              operation: 'add',
              x: 'money',
              y: '1'
            }
          ],
          lose: [
            'useless'
          ],
          fate: 'kick'
        }
      ],
      actions: []
    },
    {
      title: 'Home',
      description: 'You are at home. Living alone feels lonely\nsometimes... But you can jump on your bed\nif you like.',
      countdown: {
        visit_count: 10,
        death: 'Life is so boring that you died. Gray rats\nwho just had been lingering there\nare listlessly eating your body.'
      },
      find_money: true,
      actions: [
        {
          caption: 'Stay',
          place: 'Home'
        },
        {
          caption: 'Leave',
          place: 'Street'
        }
      ]
    },
    {
      title: 'Street',
      description: 'Fresh air! The street is crowded as usual.\nYou stand just in front of your home.\n\nWhere would you go?',
      find_money: false,
      actions: [
        {
          caption: 'Center',
          place: 'Center'
        },
        {
          caption: 'Outskirts',
          place: 'Outskirts'
        },
        {
          caption: 'Home',
          place: 'Home'
        },
        {
          caption: 'Sell',
          place: '(Trade)'
        }
      ],
      late: [
        {
          if: 'useless',
          then: 'A bad looking man is approaching.\nHe wants to sell you stolen weapons.\nHe would buy things of value, too.\nYou think of selling the piglet.'
        }
      ]
    },
    {
      title: 'Center',
      description: 'Malls and restaurants all around.\nYou feel like shopping!\n',
      find_money: false,
      poor: 'Wish you had any money :(',
      goods: [
        {
          item: {
            real_name: 'useless',
            shown_as: 'item'
          },
          get: 'You bought a golden piglet. It\'s a perfect\npresent... You just need somebody to give it.\n',
          if: 'not know secret'
        },
        {
          item: {
            real_name: 'useful',
            shown_as: 'item'
          },
          get: 'You bought some flowers for your gf.\n',
          if: 'secret'
        }
      ],
      actions: [
        {
          caption: 'Street',
          place: 'Street'
        }
      ]
    },
    {
      title: 'Outskirts',
      description: 'You remember a girl you used to know from\nschool. Maybe it\'s because she lived here. Or\nmaybe it\'s because you always think of her\never since.\n\nYou stand right at the girl\'s door.\n',
      find_money: false,
      countdown: {
        visit_count: Infinity,
        death: '** SIN Player Error **'
      },
      disorient: '',
      actions: [
        {
          caption: 'Knock',
          place: 'The Girl\'s Place'
        },
        {
          caption: '',
          place: 'Outskirts'
        },
        {
          caption: 'Street',
          place: 'Street'
        }
      ],
      enter: ''
    },
    {
      title: 'The Girl\'s Place',
      description: '\'Hey, is that really you? I remember\nthe shy guy from school. Haha!\'\nYou talk a little. She asks about your life.',
      find_money: false,
      late: [
        {
          if: 'useful',
          then: 'She loves the flowers. It\'s so nice to have her.',
          fate: 'win'
        },
        {
          if: 'have money',
          then: 'She tells you that she likes flowers.\nShe feels alone. She likes to jump on her bed.\nShe shows how.\nYou stay until the morning comes.\n',
          obtain: [
            {
              real_name: 'secret',
              shown_as: 'secret'
            }
          ]
        },
        {
          if: 'not have useful',
          then: 'She asks you to leave as she has\nimportant things to do.\n',
          fate: 'kick'
        }
      ],
      actions: []
    }
  ],
  money: {
    visit_count: 3,
    piece_count: 1,
    found: 'You stand up on the bed to jump... You feel\nsomething pushing your foot...\nHey! You found a coin below the bedsheet!\n'
  },
  conditions: [
    {
      name: 'have any item',
      operator: 'or',
      operands: [
        'useful',
        'useless'
      ]
    },
    {
      name: 'have money',
      operator: '>',
      operands: [
        'money',
        '0'
      ]
    },
    {
      name: 'give money',
      operator: '>',
      operands: [
        'money',
        '0'
      ]
    },
    {
      name: 'not have useful',
      operator: 'not',
      operands: [
        'useful'
      ]
    },
    {
      name: 'not know secret',
      operator: 'not',
      operands: [
        'secret'
      ]
    }
  ],
  shown_counters: [
    'visit count',
    'money'
  ]
};

@Injectable({
  providedIn: 'root'
})
export class AdventureService {
  adventureData: Observable<Adventure>;

  setOpener(opener): void {
    if (opener) {
      console.log("expecting adventure data from opener");
      this.adventureData = fromEvent(window, 'message').pipe(
        map(event => event as MessageEvent),
        filter(event => openerURLs.includes(event.origin) && event.data.type === 'SIN'),
        map(event => event.data.payload as Adventure)
      );
      opener.postMessage({ type: 'ANGULAR_READY' }, '*');
    } else if (location.search.match(/^\?[0-9a-f]{24}$/)) {
      this.adventureData = from(fetch(crudURL + '/' + location.search.substring(1))
        .then(response => response.json())
        .then(data => {
          console.log("initializing game from crud");
          delete data._id;
          return data;
        })
        .catch(error => {
          console.log("crud error - initializing demo game", error);
          return demoGame;
        })
      );
    } else {
      this.adventureData = from(fetch('/assets/adventure.json')
        .then(response => response.json())
        .then(data => {
          console.log("initializing deployed game");
          return data;
        })
        .catch(error => {
          console.log("file error - initializing demo game", error);
          return demoGame;
        })
      );
    }
  }

  getAdventureData(): Observable<Adventure> {
    return this.adventureData;
  }
}
